import { useEffect, useRef, useState } from "react";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import { Container, Card } from 'reactstrap';
import useAwardsIndustryRecognition from '@/hooks/useAwardsIndustryRecognition';
import Link from "next/link"
import styles from './styles.module.scss';
import Marquee from "react-marquee-slider";

export const Awards = ({
    className,
    title,
    heading,
    titleColour,
    selectedItems,
    showGraphics,
    speed,
}) => {

    const items = useAwardsIndustryRecognition();

    const filteredItems = selectedItems?.length > 0 ? items.filter((item) => selectedItems?.includes(item?.id)) : items;

    const DEFAULT_SPEED = 150;
    const desiredSpeed = Number(speed) > 0 ? Number(speed) : DEFAULT_SPEED;
    const marqueeParentRef = useRef(null);
    const [velocity, setVelocity] = useState(desiredSpeed);

    // react-marquee-slider's animation always lasts containerWidth / velocity seconds,
    // but each cycle travels the full strip width, so the perceived speed grows with
    // the amount of content. Scale velocity by containerWidth / stripWidth so the
    // configured speed is the real px/s on every page.
    useEffect(() => {
        const parent = marqueeParentRef.current;
        if (!parent) return;

        const measure = () => {
            const container = parent.firstElementChild;
            const strip = container?.firstElementChild;
            if (!container?.clientWidth || !strip?.scrollWidth) return;
            setVelocity((desiredSpeed * container.clientWidth) / strip.scrollWidth);
        };

        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(parent);
        if (parent.firstElementChild?.firstElementChild) {
            observer.observe(parent.firstElementChild.firstElementChild);
        }
        return () => observer.disconnect();
    }, [desiredSpeed, filteredItems?.length]);

    if (!filteredItems || !filteredItems.length > 0) {
        return null;
    }

    return (
        <section className={`${styles.root} ${className} ${showGraphics && styles.graphics} overflow-hidden`}>
            <Container className="py-4 py-md-5">
                {title &&
                    <div className={`mb-5 ${showGraphics && `px-5`}`}>
                        <h2
                            className={`text-${titleColour?.variant} ${heading} mb-1`}
                            style={titleColour?.custom ? { color: titleColour?.custom } : null}
                        >
                            {title}
                        </h2>
                    </div>
                }
                <div className="marquee-parent position-relative" ref={marqueeParentRef}>
                    <Marquee
                        velocity={velocity}>
                        {filteredItems.map((item, index) => (
                            <Card key={index} className="rounded-0 bg-transparent border-0 align-items-center mx-5">
                                {item?.link ?
                                    <Link href={`${item?.link}`}>
                                        <a title={`${item?.title}`}>
                                            <SourceFlowImage
                                                src={item?.image}
                                                size="500x"
                                                alt={item?.title}
                                                width="100%"
                                                height="100%"
                                                className="card-img rounded-0 m-auto"
                                            />
                                        </a>
                                    </Link>
                                :
                                    <SourceFlowImage
                                        src={item?.image}
                                        size="500x"
                                        alt={item?.title}
                                        width="100%"
                                        height="100%"
                                        className="card-img rounded-0 m-auto"
                                    />
                                }
                            </Card>
                        ))}
                    </Marquee>
                </div>
            </Container>
        </section>
    )
}

export default Awards;
